<div class="d-flex flex-column">
  @if (sapCuratedNote) {
    <div id="partDetails_div_SAPCuratedNote" class="p-3 border-bottom">
      <h5 class="strong text-muted">SAP Part Administrator Notes:</h5>
      <div>{{sapCuratedNote}}</div>
    </div>
  }

  <div class="px-3 py-2 gx-2 border-bottom">
    <span>Sort By:</span>
    <span ngbDropdown>
      <button id="partDetails_button_NoteSortDirection" class="btn btn-sm btn-outline-secondary" ngbDropdownToggle>
        @switch (sortAscending$ | async) {
          @case (false) {
            Newest to Oldest
          }
          @case (true) {
            Oldest to Newest
          }
        }
      </button>
      <div ngbDropdownMenu>
        <button id="partDetails_button_NewestToOldest" class="dropdown-item" (click)="setSortAscending(false)">
          Newest to Oldest
        </button>
        <button id="partDetails_button_OldestToNewest" class="dropdown-item" (click)="setSortAscending(true)">
          Oldest to Newest
        </button>
      </div>
    </span>
  </div>

  <div *ngLet="edit$ | async as edit" class="flex-grow-1" style="overflow-y:auto; max-height:190px;">
    @for (note of (notes$ | async); track note; let i = $index) {
      <div id="partDetails_div_Note_{{i}}"
        class="p-3 border-bottom d-flex justify-content-between align-items-baseline">
        @if (edit && edit.id === note.id) {
          <form class="w-100" #editNgForm="ngForm" (ngSubmit)="updateNote(editNgForm.form)">
            <fieldset [disabled]="edit.submitting">
              <div class="input-group input-group-sm">
                <input type="hidden" name="id" [ngModel]="edit.id">
                <input id="partNotes_editForm_text_description" type="text" class="form-control" name="description" placeholder="Add a Note" [ngModel]="edit.description" required>
                <span class="input-group-text">
                  <i class="far fa-comment" aria-hidden="true"></i>
                </span>
                <button id="partNotes_editForm_button_cancel" type="button" class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
                <button id="partNotes_editForm_button_submit" type="submit" class="btn btn-secondary"
                  [disabled]="!editNgForm.form.dirty || !editNgForm.form.valid">
                  Update Note
                </button>
              </div>
            </fieldset>
          </form>
        } @else {
          <div>
            <div>{{note.createdDate | date: 'MM/dd/yyyy'}}</div>
            <div>{{note.description}}</div>
            @if (isInternal$) {
              <div>Submitted by: {{note.createdByUserName | emailToUserName | uppercase}}</div>
            }
          </div>
          @if ((hasSomeModifyPermission$ | async) || note.createdBy === (userId$ | async)) {
            <div ngbDropdown container="body" placement="bottom-right">
              <button ngbDropdownToggle class="btn btn-sm btn-outline-secondary">
                <i class="fas fa-ellipsis-h"></i>
              </button>
              <div ngbDropdownMenu>
                @if ((hasEditPermission$ | async) || note.createdBy === (userId$ | async)) {
                  <button ngbDropdownItem (click)="editNote(note.id, note.description)">
                    <i class="fas fa-pencil-alt"></i>
                    Edit
                  </button>
                }
                @if ((hasDeletePermission$ | async) || note.createdBy === (userId$ | async)) {
                  <button ngbDropdownItem (click)="deleteNote(note.id)">
                    <i class="far fa-trash-alt"></i>
                    Delete
                  </button>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>

  @if (authorizationService.hasPermission(permission.CreatePartNotes)) {
    <form id="partDetails_form_CreatePartNotes" class="p-3"
      #ngForm="ngForm" (ngSubmit)="createNote(ngForm.form)">
      <fieldset [disabled]="!partNumber">
        <div class="input-group input-group-sm">
          <input id="partDetails_text_NoteText" type="text" class="form-control" name="description" placeholder="Add a Note" ngModel required>
          <span class="input-group-text">
            <i class="far fa-comment" aria-hidden="true"></i>
          </span>
          <button id="partDetails_button_AddNoteSubmit" type="submit" class="btn btn-secondary"
            [disabled]="!ngForm.form.dirty || !ngForm.form.valid">
            Add Note
          </button>
        </div>
      </fieldset>
      @if (!partNumber) {
        <div class="alert alert-warning m-0">Product notes cannot be created for a non-SAP part.</div>
      }
    </form>
  }
</div>